class Storage {
    constructor(){
        this.initialize()
    }
    properties() {
        this.sProxy = window.localStorage
        // 60 * 60 *24 *30 *1000 ms === 30天
        this.defaultLifeTime = 2592000000
        //本地缓存用以存放所有localstorage键值与过期的映射
        this.keyCache = 'SYSTEM_KEY_TIME_MAP'
        //当缓存容量已满，每次删除的缓存数
        this.removeNum = 5
    }

    assert() {
        if (this.sProxy === null) {
            throw 'no override sProxy property'
        }
    }

    initialize(){
        this.properties()
        this.assert()
    }


    set(key, value, timeout, sign) {
        const _d = new Date()
        //存入日期
        const indate = _d.getTime()
        //最终保存的数据
        let entity = null

        if (!timeout) {
            _d.setTime(_d.getTime() + this.defaultLifeTime)
            timeout = _d.getTime()
        }

        this.setKeyCache(key, timeout)
        entity = this.buildStorageObj(value, indate, timeout, sign)

        try {
            this.sProxy.setItem(key, JSON.stringify(entity))
            return true
        } catch (e) {
            //localstorage写满时，全清掉
            if (e.name === 'QuotaExceedeError') {

                //localstorage写满时，选择离过期时间最近的数据删除
                if (!this.removeLastCache()) throw '本次数据存储量过大'

                this.set(key, value, timeout, sign)
            }
            console && console.log(e)

        }
        return false

    }

    //删除过期缓存
    removeOverdueCache() {
        let tmpObj = null, i, len

        const now = new Date().now()

        //取出键值对
        const cacheStr = this.sProxy.getItem(this.keyCache)
        let cacheMap = []
        let newMap = []

        if (!cacheStr) {
            return
        }

        cacheMap = JSON.parse(cacheStr)

        for (i = 0, len = cacheMap.length; i < len; i++) {
            tmpObj = cacheMap[i]
            if (tmpObj.timeout < now) {
                this.sProxy.removeItem(tmpObj.key)
            } else {
                newMap.push(tmpObj)
            }

        }

        this.sProxy.setItem(this.keyCache, JSON.stringify(newMap))

    }

    removeLastCache() {
        let i, len
        const num = this.removeNum || 5

        //取出键值对
        const cacheStr = this.sProxy.getItem(this.keyCache)
        let cacheMap = []
        let delMap = []

        if (!cacheStr) return false

        cacheMap.sort((a, b) => a.timeout - b.timeout)

        delMap = cacheMap.splice(0, num)
        for (i = 0, len = delMap.length; i < len; i++) {
            this.sProxy.removeItem(delMap[i].key)
        }

        this.sProxy.setItem(this.keyCache, JSON.stringify(cacheMap))
        return true
    }

    setKeyCache(key, timeout) {
        if (!key || !timeout || timeout < new Date().getTime()) return

        let i, len, tmpObj

        //获取当前已经缓存的键值字符
        const oldStr = this.sProxy.getItem(this.keyCache)
        let oldMap = []

        //当前key是否已经存在
        let flag = false
        let obj = {}
        obj.key = key
        obj.timeout = timeout

        if (oldStr) {
            oldMap = JSON.parse(oldStr)
            if (!Array.isArray(oldMap)) oldMap = []
        }

        for (i = 0, len = oldMap.length; i < len; i++) {
            tmpObj = oldMap[i]
            if (tmpObj.key === key) {
                oldMap[i] = obj
                flag = true
                break
            }
        }

        if (!flag) oldMap.push(obj)

        this.sProxy.setItem(this.keyCache, JSON.stringify(oldMap))

    }

    buildStorageObj(value, indate, timeout, sign) {
        const obj = {
            value,
            timeout,
            sign,
            indate
        }

        return obj

    }

    get(key, sign) {
        let result, now = new Date().getTime()

        try {
            result = this.sProxy.getItem(key)
            if (!result) return null
            result = JSON.parse(result)

            if (result.timeout < now) return null

            if (sign) {
                if (sign === result.sign) {
                    return result.value
                }
                return null
            } else {
                return result.value
            }

        } catch (e) {
            console && console.log(e)
        }

        return null

    }

    getSign(key) {
        let result, sign = null
        try {
            result = this.sProxy.getItem(key)
            if (result) {
                result = JSON.parse(result)
                sign = result && result.sign
            }
        } catch (e) {
            console && console.log(e)
        }

        return sign

    }

    remove(key) {
        return this.sProxy.removeItem(key)
    }

    clear() {
        this.sProxy.clear()
    }

}

export default Storage